import { render, staticRenderFns } from "./featureManagement.vue?vue&type=template&id=8b0d1206&scoped=true"
import script from "./featureManagement.vue?vue&type=script&lang=js"
export * from "./featureManagement.vue?vue&type=script&lang=js"
import style0 from "./featureManagement.vue?vue&type=style&index=0&id=8b0d1206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0d1206",
  null
  
)

export default component.exports